<template>
  <div class="casa">
    <v-card class="mx-auto" max-width="344" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <div class="text-overline mb-4">WAVELY</div>
          <v-list-item-title class="text-subtitle-2 mb-1">
            Wavely Hospitality Services
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-avatar rounded="circle" size="80" color="grey">
          <v-img
            :src="require('../assets/wavely_logo.jpeg')"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions class="mx-auto">
        <v-btn outlined rounded text small :to="{ name: 'jobsWavely' }" block>
          Apply
        </v-btn>

        
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Casa",
  components: {},

  data() {
    return {};
  },

  methods: {},
  watch: {
    $route() {},
  },
  mounted() {},
  computed: {},
};
</script>
